<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div class="tabs mt-4">
      <div
        v-for="(tab, index) in tabs"
        :key="tab"
        :class="{'tab-active': index === 0}"
        class="tab-list"
      >
        {{ tab }}
      </div>
    </div>

    <div class="mt-3">
      <b-button
        class="btn grey btn-import-form m__r--5"
        disabled
      >
        <i class="fa fa-plus fa-lg"/> Add
      </b-button>
      <b-button
        class="btn grey btn-import-form"
        disabled
      >
        <i class="fa fa-search fa-lg"/> Search
      </b-button>
    </div>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      tabs: [
        'ATTENDANCE CODE',
        'REMINDER',
        'HOLIDAY',
        'SHIFT',
        'MAPPING SHIFT',
        'AUTOMATIC ATTENDANCE',
        'VENUE',
      ],
      columns: [
        'NAME',
        'DESCRIPTION',
        'CREATED DATE',
        'UPDATED DATE',
        'UPDATED BY',
        'START DATE',
        'END DATE',
        'STATUS',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: scroll;

  .tab-list {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    color: $gray-1;
    white-space: nowrap;
    padding-bottom: 7px;
    margin-right: 20px;
    border-bottom: 4px solid transparent;

    &.tab-active {
      border-color: $primary;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyAttendanceConfig.vue